/* global axios */
import ApiClient from './ApiClient';

// Reusa o controller existente BmtEvolutionInboxesController (acao :health agregada).
// URL: /api/v1/accounts/:account_id/bmt_evolution_inboxes/health
class BmtInboxHealthAPI extends ApiClient {
  constructor() {
    super('bmt_evolution_inboxes', { accountScoped: true });
  }

  getHealth() {
    return axios.get(`${this.url}/health`);
  }
}

export default new BmtInboxHealthAPI();
